module.exports = __webpack_public_path__ + "static/media/spkr_rm.39f45176.png";